(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.wrapper = this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.bindInteractiveStates();
      this.updateSolidState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    bindInteractiveStates() {
      if (
        !this.wrapper ||
        (
          !this.wrapper.classList.contains('header-wrapper--transparent-home') &&
          !this.wrapper.classList.contains('header-wrapper--transparent-page')
        )
      ) return;

      document.addEventListener('mouseover', (event) => {
        if (event.target.closest('.header')) {
          this.wrapper.classList.add('menu-open');
          this.updateSolidState();
        }
      });

      document.addEventListener('mouseout', (event) => {
        if (event.target.closest('.header')) {
          setTimeout(() => {
            const activeOpen =
              this.querySelector('details[open]') ||
              document.querySelector('.menu-drawer-container details[open]') ||
              document.querySelector('.search-modal[open]');

            if (!activeOpen) {
              this.wrapper.classList.remove('menu-open');
              this.updateSolidState();
            }
          }, 10);
        }
      });

      document.addEventListener('click', () => {
        setTimeout(() => this.updateSolidState(), 50);
      });

      document.addEventListener('focusin', (event) => {
        if (event.target.closest('.header')) {
          this.wrapper.classList.add('menu-open');
          this.updateSolidState();
        }
      });

      document.addEventListener('focusout', () => {
        setTimeout(() => {
          const activeOpen =
            this.querySelector('details[open]') ||
            document.querySelector('.menu-drawer-container details[open]') ||
            document.querySelector('.search-modal[open]');

          if (!activeOpen) {
            this.wrapper.classList.remove('menu-open');
          }

          this.updateSolidState();
        }, 50);
      });
    }

    updateSolidState() {
      if (
        !this.wrapper ||
        (
          !this.wrapper.classList.contains('header-wrapper--transparent-home') &&
          !this.wrapper.classList.contains('header-wrapper--transparent-page')
        )
      ) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const menuOpen =
        this.wrapper.classList.contains('menu-open') ||
        this.querySelector('details[open]') ||
        document.querySelector('details[open].menu-opening') ||
        document.querySelector('.menu-drawer-container details[open]') ||
        document.querySelector('.search-modal[open]');

      if (scrollTop > 10 || menuOpen) {
        this.wrapper.classList.add('is-solid');
      } else {
        this.wrapper.classList.remove('is-solid');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.updateSolidState();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
